import { createStore } from 'redux';
import allReducer from './reducers/rootReducer';

function configureStore(state = { activeState: { landing: false }, activeModal: { model: false } }) {
  return createStore(allReducer,state);
}

export default configureStore;